/**
 * Lỗi nạp một chunk của chính app qua `import()` động — không phải lỗi của dữ liệu.
 *
 * Gặp ở hai chỗ: dev server của Vite vừa tối ưu thêm dep mới (lần đầu mở một tính năng nạp lười,
 * request chunk cũ trả 504 "Outdated Optimize Dep"), và production sau một lần deploy (tab mở từ
 * trước còn trỏ tên chunk cũ, đã bị xoá). Cả hai chỉ khỏi khi **tải lại trang** — báo "tệp hỏng"
 * hay "chuyển không thành công" là đẩy người dùng đi thử lại thứ không bao giờ khỏi (QA APM-CVT,
 * 2026-10-14).
 *
 * Mỗi trình duyệt một câu: Chrome "Failed to fetch dynamically imported module", Firefox "error
 * loading dynamically imported module", Safari "Importing a module script failed"; webpack/Rollup
 * cũ "ChunkLoadError" / "Loading chunk … failed"; preload của Vite "Unable to preload CSS".
 * Lỗi bọc lại (`cause`) cũng tính.
 */
const CHUNK_LOAD_MESSAGE =
  /dynamically imported module|importing a module script failed|loading (css )?chunk [\w-]+ failed|unable to preload css/i;

export function isChunkLoadError(error: unknown): boolean {
  for (let current = error, depth = 0; current && depth < 5; depth += 1) {
    if (!(current instanceof Error)) return false;
    if (current.name === 'ChunkLoadError' || CHUNK_LOAD_MESSAGE.test(current.message)) return true;
    current = current.cause;
  }
  return false;
}
